import React from 'react';
import { useTranslation } from 'react-i18next';
import { Globe2 } from 'lucide-react';
import { rwLabel } from '@/constants/remoteWork';

export const RemoteBadge = ({ job }) => {
  const { i18n } = useTranslation();
  if (!job || !['remoto', 'hibrido'].includes(job.work_mode)) return null;
  const remote = job.work_mode === 'remoto';
  return (
    <span
      className={`inline-flex items-center gap-1 px-2 py-0.5 text-[10px] uppercase tracking-widest font-bold rounded ${remote ? 'bg-emerald-50 text-emerald-800' : 'bg-sky-50 text-sky-800'}`}
      data-testid={`job-workmode-badge-${job.id}`}
    >
      <Globe2 className="h-3 w-3" aria-hidden="true" />
      {rwLabel(i18n.language, job.work_mode)}
    </span>
  );
};
